import React from "react";
import {
    Dialog, DialogTitle, DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import { appColors } from "../../../../constants/theme";

const ExitConfirmationDialog = ({ open, onClose, onConfirm, isSaveMode = false }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '20px',
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',

                }
            }}
        >
            <DialogTitle sx={{
                textAlign: 'center',
                fontWeight: 700,
                color: appColors.infoDark,
                fontSize: '1.5rem',
                pt: 4
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                    <Warning sx={{ fontSize: 48, color: appColors.warning, mr: 2 }} />
                </Box>
                {isSaveMode ? "Kaydet" : "Çıkış Onayı"}
            </DialogTitle>

            <DialogContent dividers sx={{ px: 4, py: 3 }}>
                <Typography
                    variant="body1"
                    align="center"
                    sx={{
                        mb: 2,
                        color: appColors.gray500,
                        fontSize: '1.1rem',
                        lineHeight: 1.6
                    }}
                >
                    {isSaveMode
                        ? "Bilgileri kaydetmek istiyor musunuz?"
                        : "Kayıt işlemini yarıda bırakmak istediğinizden emin misiniz? Girilen bilgiler kaydedilmeyecektir."}
                </Typography>
            </DialogContent>

            <DialogActions sx={{
                justifyContent: 'center',
                pb: 4,
                px: 4,
                gap: 2
            }}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        minWidth: 150,
                        fontWeight: 600,
                        borderRadius: '12px',
                        borderColor: appColors.info,
                        color: appColors.infoDark,
                        py: 1.5,
                        '&:hover': {
                            borderColor: appColors.infoDark,
                            backgroundColor: 'rgba(116, 185, 255, 0.08)',
                        }
                    }}
                >
                    Vazgeç
                </Button>

                <Button
                    variant="contained"
                    onClick={onConfirm}
                    sx={{
                        minWidth: 150,
                        fontWeight: 600,
                        borderRadius: '12px',
                        background: isSaveMode
                            ? `linear-gradient(135deg, ${appColors.primary} 0%, ${appColors.primaryTeal} 100%)`
                            : `linear-gradient(135deg, ${appColors.warning} 0%, ${appColors.warningDark} 100%)`,
                        py: 1.5,
                        '&:hover': {
                            background: isSaveMode
                                ? `linear-gradient(135deg, ${appColors.primaryDark} 0%, ${appColors.primary} 100%)`
                                : `linear-gradient(135deg, ${appColors.warningDark} 0%, ${appColors.warning} 100%)`,
                            transform: 'translateY(-1px)',
                        },
                        transition: 'all 0.3s ease'
                    }}
                >
                    {isSaveMode ? "Kaydet" : "Çıkış Yap"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ExitConfirmationDialog; 